import PropTypes from 'prop-types';
import './Card.css';

export function Card({ children, className = '', onClick, hoverable = false }) {
    return (
        <div
            className={`card ${hoverable ? 'card-hoverable' : ''} ${className}`}
            onClick={onClick}
        >
            {children}
        </div>
    );
}

export function CardHeader({ children, className = '', action }) {
    return (
        <div className={`card-header ${className}`}>
            <div className="card-header-content">{children}</div>
            {action && <div className="card-header-action">{action}</div>}
        </div>
    );
}

export function CardBody({ children, className = '' }) {
    return <div className={`card-body ${className}`}>{children}</div>;
}

export function CardFooter({ children, className = '' }) {
    return <div className={`card-footer ${className}`}>{children}</div>;
}

Card.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    onClick: PropTypes.func,
    hoverable: PropTypes.bool
};

CardHeader.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    action: PropTypes.node
};

CardBody.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};

CardFooter.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};

export default Card;
